export default __webpack_public_path__ + "static/media/hotelcard-logo.b974bef5.png";